import React from 'react';
import styled from 'styled-components';
import { PodCast } from '../svg';
import Button from '../../../../../../../FlyfishComponents/Button';
import { Tooltip } from '@mui/material';

const PodCastDiv = styled.div`
	& > .container {
		display: flex;
		& > .media {
			cursor: pointer;
			position: relative;
			& > img {
				width: 318px;
				max-height: 164px;
				border-radius: 11px;
				object-fit: cover;
			}
			& > svg {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
		}
		& > .content {
			max-height: 164px;
			cursor: pointer;
			margin-left: 25px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			& > p {
				display: -webkit-box;
				-webkit-line-clamp: 1;
				-webkit-box-orient: vertical;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: normal;
				&.ff-chatbot-body2 {
					margin: 10px 0;
					opacity: 0.5;
					font-size: 1.1em !important;
				}
			}

			& > .custom-button {
				& > button {
					background: #ffb100 !important;
					border-radius: 18px !important;
					& > div {
						color: black !important;
					}
				}
			}
		}
	}
`;

type Props = {
	url: string;
	heading: string;
	desc: string;
	redirectURL: string;
};

const PodCasts = ({ url, heading, desc, redirectURL = '' }: Props) => {
	return (
		<PodCastDiv>
			<div className='container'>
				<div className='media' onClick={() => window.open(redirectURL)}>
					<img src={url} alt='' />
					<PodCast />
				</div>
				<div className='content' onClick={() => window.open(redirectURL)}>
					<Tooltip title={heading}>
						<p className='ff-chatbot-h6'>{heading}</p>
					</Tooltip>
					<Tooltip title={desc}>
						<p className='ff-chatbot-body2'>{desc}</p>
					</Tooltip>
					<Button>Listen Now</Button>
				</div>
			</div>
		</PodCastDiv>
	);
};

export default PodCasts;
